<div class="c-modal is-open" id="modal-deactivationConfirm" aria-hidden="false"
     (keydown.enter)="$event.preventDefault()">
  <div class="c-modal__overlay" tabindex="-1">
    <div class="c-modal__body" role="dialog" aria-modal="false">
      <div class="c-modal__header">
        <h2>
          Pristup lekciji ograničen
        </h2>
        <button class="c-modal__close e-close" role="button" aria-label="Zatvori" (click)="close()"></button>
      </div>
      <div class="c-modal__content">
        <div class="c-test__content u-centered">
          <div class="c-editor">
            <p *ngIf="!user">Molimo da se prijavite ili registrirate za pristup lekciji.</p>
            <p *ngIf="user">Molimo da upišete tečaj za pristup lekciji.</p>
          </div>
        </div>
      </div>
      <div class="c-modal__footer">
        <div class="c-group">
          <button class="c-btn is-text" (click)="close()">Zatvori</button>
          <button class="c-btn is-primary" *ngIf="!user" (click)="close()" [routerLink]="['/login']"
                  [queryParams]="{path: '/courses/' + course.urlSlug}">Prijava</button>
          <button class="c-btn is-primary" *ngIf="user" [class.is-loading]="enrolling"
                  (click)="enrollCourse()">Upiši tečaj</button>
        </div>
      </div>
    </div>
  </div>
</div>
